







































import { Vue, Component, Prop } from 'vue-property-decorator'
// import appMusicPlayer from '@/components/AppMusicPlay/AppMusicPlay.vue'
@Component
export default class AppHead extends Vue {
  @Prop({ default: '/' }) active!: string
  @Prop({ default: 'on' }) activeClassName!: string

  audio: HTMLAudioElement | null = null
  component: HTMLAudioElement | null = null

  to (path: string) {
    Lib.router.push(path)
  }
  mounted () {
    let cover: any = document.querySelector('.cover')
    let menu: any = document.querySelector('.menu')
    let nav: any = document.querySelector('.nav-box')
    let navList: any = document.querySelector('.nav-list')
    let page: any = document.querySelector('.main')
    if (menu) {
      menu.addEventListener('click', (e: any) => {
        cover.classList.remove('none')
        // navList.classList.remove('none')
        navList.classList.remove('hide')
        nav.style.width = '50%'
        let video: any = document.querySelector('.control')
        let img: any = document.querySelector('.videoImg')
        if (video) {
          video.pause()
          video.classList.add('none')
          if (img) {
            img.classList.remove('none')
          }
        }
      })
    }
    if (cover) {
      cover.addEventListener('click', () => {
        cover.classList.add('none')
        navList.classList.add('hide')
        nav.style.width = '0%'
        let video: any = document.querySelector('.control')
        let img: any = document.querySelector('.videoImg')
        if (video) {
          video.pause()
          video.classList.remove('none')
          if (img) {
            img.classList.add('none')
          }
        }
      })
    }
    let logo: any = document.querySelector('.logo')
    let logo2: any = document.querySelector('.logo2')
    if (logo) {
      logo.addEventListener('click', () => {
        console.log('点击')
        this.to('/')
      })
    }
    if (logo2) {
      logo2.addEventListener('click', () => {
        console.log('点击')
        Lib.router.push('/')
      })
    }
  }
}
